import arneSubmission from '../assets/sampleData/arne/Math_test_6th_grade.pdf?url';
import kaarstSubmission from '../assets/sampleData/kaarst/Kaarst_gesamtschule_mathe_gk.pdf?url';
import kaarstGs from '../assets/sampleData/kaarst/Kaarst_gesamtschule_mathe_gk_Bewertungsschema.pdf?url';
import kaarstBlank from '../assets/sampleData/kaarst/Kaarst_gesamtschule_mathe_gk_blank_exam.pdf?url';
import kaarstMs from '../assets/sampleData/kaarst/Kaarst_gesamtschule_mathe_gk_Musterloesung.pdf?url';
// import lynMathSubmissionShort from '../assets/sampleData/lyneham-math/Lyneham_Grundschule_Mathe_short.pdf?url';
// import tuebBauleiterSubmission from '../assets/sampleData/tuev-bauleiter/TUEV_Bauleiter_E102844.pdf?url';
// import tuebBauleiterMs from '../assets/sampleData/tuev-bauleiter/TUEV_Bauleiter_E102844_Musterloesung.pdf?url';
// import tuvPhotovoltaikSubmission from '../assets/sampleData/tuv-photovoltaik/TUEV_Photovoltaik_E102883.pdf?url';
// import tuvPhotovoltaikMs from '../assets/sampleData/tuv-photovoltaik/TUEV_Photovoltaik_E102883_Musterloesung.pdf?url';
// import lynReadingSubmission from '../assets/sampleData/lyneham-reading/Lyneham_Grundschule_reading.pdf?url';
// import lynReadingGs from '../assets/sampleData/lyneham-reading/Lyneham_Grundschule_reading_grading_scheme.pdf?url';
// import lynReadingBlank from '../assets/sampleData/lyneham-reading/Lyneham_Grundschule_reading_blank_exam.pdf?url';
// import tuvDatenschutzSubmission from '../assets/sampleData/tuv-datenschutz/TUEV_Datenschutzauditor.pdf?url';
// import tuvDatenschutzMs from '../assets/sampleData/tuv-datenschutz/TUEV_Datenschutzauditor_Musterloesung.pdf?url';
import math_proof_eng_blank_exam from '../assets/sampleData/artifial_math_proof/eng/mathematics_proofs_blank_exam.pdf?url';
import math_proof_eng_gs from '../assets/sampleData/artifial_math_proof/eng/mathematics_proofs_grading_scheme.pdf?url';
import math_proof_eng_ms from '../assets/sampleData/artifial_math_proof/eng/mathematics_proofs_master_solution.pdf?url';
import math_proof_eng_submission from '../assets/sampleData/artifial_math_proof/eng/student_submissions.pdf?url';
import math_proof_fr_blank_exam from '../assets/sampleData/artifial_math_proof/french/blank_exam.pdf?url';
import math_proof_fr_gs from '../assets/sampleData/artifial_math_proof/french/grading_scheme.pdf';
import math_proof_fr_ms from '../assets/sampleData/artifial_math_proof/french/master_solution.pdf';
import math_proof_fr_submission from '../assets/sampleData/artifial_math_proof/french/student_submission.pdf?url';
import bio_imageLabel_blank from '../assets/sampleData/artifical_bio_imageLabel/blank_exam.pdf?url';
import bio_imageLabel_ms from '../assets/sampleData/artifical_bio_imageLabel/musterloesung_bild.pdf?url';
import bio_imageLabel_submissions from '../assets/sampleData/artifical_bio_imageLabel/schuelerabgaben.pdf?url';
import calculation_blank from '../assets/sampleData/artifical_calculation/de/oberstufe_physik_klausur_blank.pdf?url';
import calculation_gs from '../assets/sampleData/artifical_calculation/de/oberstufe_physik_klausur_gs.pdf?url';
import calculation_ms from '../assets/sampleData/artifical_calculation/de/oberstufe_physik_klausur_ms.pdf?url';
import calculation_submissions from '../assets/sampleData/artifical_calculation/de/oberstufe_physik_klausur_submissions.pdf?url';
import dictation_blank_es from '../assets/sampleData/artifical_dictation/es/klausur_diktat_es_blank.pdf?url';
import dictation_gs_es from '../assets/sampleData/artifical_dictation/es/klausur_diktat_es_gs.pdf?url';
import dictation_ms_es from '../assets/sampleData/artifical_dictation/es/klausur_diktat_es_ms.pdf?url';
import dictation_submission_es from '../assets/sampleData/artifical_dictation/es/klausur_diktat_es_submissions.pdf?url';
import dictation_blank_fr from '../assets/sampleData/artifical_dictation/fr/klausur_diktat_fr_blank.pdf?url';
import dictation_gs_fr from '../assets/sampleData/artifical_dictation/fr/klausur_diktat_fr_gs.pdf?url';
import dictation_ms_fr from '../assets/sampleData/artifical_dictation/fr/klausur_diktat_fr_ms.pdf?url';
import dictation_submission_fr from '../assets/sampleData/artifical_dictation/fr/klausur_diktat_fr_submissions.pdf?url';
import eng_vocabulary_blank_exam from '../assets/sampleData/artifical_eng_vocabulary/eng_vocabulary_blank_exam.pdf?url';
import eng_vocabulary_gs from '../assets/sampleData/artifical_eng_vocabulary/eng_vocabulary_grading_scheme.pdf?url';
import eng_vocabulary_ms from '../assets/sampleData/artifical_eng_vocabulary/eng_vocabulary_master_solution.pdf?url';
import eng_vocabulary_submission from '../assets/sampleData/artifical_eng_vocabulary/eng_vocabulary_submissions.pdf?url';
import calculation_english_blank from '../assets/sampleData/calculation_english/blank_exam.pdf?url';
import calculation_english_gs from '../assets/sampleData/calculation_english/grading_scheme.pdf?url';
import calculation_english_ms from '../assets/sampleData/calculation_english/master_solution.pdf?url';
import calculation_english_submission from '../assets/sampleData/calculation_english/submissions.pdf?url';
import calculation_french_blank from '../assets/sampleData/calculation_french/blank_exam.pdf?url';
import calculation_french_gs from '../assets/sampleData/calculation_french/grading_scheme.pdf?url';
import calculation_french_ms from '../assets/sampleData/calculation_french/master_solution.pdf?url';
import calculation_french_submission from '../assets/sampleData/calculation_french/submissions.pdf?url';
import calculation_german_blank from '../assets/sampleData/calculation_german/blank_exam.pdf?url';
import calculation_german_gs from '../assets/sampleData/calculation_german/grading_scheme.pdf?url';
import calculation_german_ms from '../assets/sampleData/calculation_german/master_solution.pdf?url';
import calculation_german_submission from '../assets/sampleData/calculation_german/submissions.pdf?url';
import calculation_spanish_blank from '../assets/sampleData/calculation_spanish/blank_exam.pdf?url';
import calculation_spanish_gs from '../assets/sampleData/calculation_spanish/grading_scheme.pdf?url';
import calculation_spanish_ms from '../assets/sampleData/calculation_spanish/master_solution.pdf?url';
import calculation_spanish_submission from '../assets/sampleData/calculation_spanish/submissions.pdf?url';
import curve_blank from '../assets/sampleData/curve_analysis/curve_blank.pdf?url';
import curve_gs from '../assets/sampleData/curve_analysis/curve_gs.pdf?url';
import curve_ms from '../assets/sampleData/curve_analysis/curve_ms.pdf?url';
import curve_submissions from '../assets/sampleData/curve_analysis/curve_submissions.pdf?url';
import material_based_english_blank from '../assets/sampleData/material_based_english/blank_exam.pdf?url';
import material_based_english_gs from '../assets/sampleData/material_based_english/grading_scheme.pdf?url';
import material_based_english_ms from '../assets/sampleData/material_based_english/master_solution.pdf?url';
import material_based_english_submission from '../assets/sampleData/material_based_english/submissions.pdf?url';
import material_based_german_blank from '../assets/sampleData/material_based_german/blank_exam.pdf?url';
import material_based_german_gs from '../assets/sampleData/material_based_german/grading_scheme.pdf?url';
import material_based_german_ms from '../assets/sampleData/material_based_german/master_solution.pdf?url';
import material_based_german_submission from '../assets/sampleData/material_based_german/submissions.pdf?url';
import multiple_choice_english_blank from '../assets/sampleData/multiple_choice_english/blank_exam.pdf?url';
import multiple_choice_english_gs from '../assets/sampleData/multiple_choice_english/grading_scheme.pdf?url';
import multiple_choice_english_ms from '../assets/sampleData/multiple_choice_english/master_solution.pdf?url';
import multiple_choice_english_submission from '../assets/sampleData/multiple_choice_english/submissions.pdf?url';
import multiple_choice_french_blank from '../assets/sampleData/multiple_choice_french/blank_exam.pdf?url';
import multiple_choice_french_gs from '../assets/sampleData/multiple_choice_french/grading_scheme.pdf?url';
import multiple_choice_french_ms from '../assets/sampleData/multiple_choice_french/master_solution.pdf?url';
import multiple_choice_french_submission from '../assets/sampleData/multiple_choice_french/submissions.pdf?url';
import multiple_choice_german_blank from '../assets/sampleData/multiple_choice_german/blank_exam.pdf?url';
import multiple_choice_german_gs from '../assets/sampleData/multiple_choice_german/grading_scheme.pdf?url';
import multiple_choice_german_ms from '../assets/sampleData/multiple_choice_german/master_solution.pdf?url';
import multiple_choice_german_submission from '../assets/sampleData/multiple_choice_german/submissions.pdf?url';
import multiple_choice_spanish_blank from '../assets/sampleData/multiple_choice_spanish/blank_exam.pdf?url';
import multiple_choice_spanish_gs from '../assets/sampleData/multiple_choice_spanish/grading_scheme.pdf?url';
import multiple_choice_spanish_ms from '../assets/sampleData/multiple_choice_spanish/master_solution.pdf?url';
import multiple_choice_spanish_submission from '../assets/sampleData/multiple_choice_spanish/submissions.pdf?url';
import plot_blank from '../assets/sampleData/plotting/plot_blank.pdf?url';
import plot_exam from '../assets/sampleData/plotting/plot_exam.pdf?url';
import plot_gs from '../assets/sampleData/plotting/plot_gs.pdf?url';
import plot_ms from '../assets/sampleData/plotting/plot_ms.pdf?url';
import poetry_english_blank from '../assets/sampleData/poetry_english/blank_exam.pdf?url';
import poetry_english_gs from '../assets/sampleData/poetry_english/grading_scheme.pdf?url';
import poetry_english_ms from '../assets/sampleData/poetry_english/master_solution.pdf?url';
import poetry_english_submission from '../assets/sampleData/poetry_english/submissions.pdf?url';
import poetry_french_blank from '../assets/sampleData/poetry_french/blank_exam.pdf?url';
import poetry_french_gs from '../assets/sampleData/poetry_french/grading_scheme.pdf?url';
import poetry_french_ms from '../assets/sampleData/poetry_french/master_solution.pdf?url';
import poetry_french_submission from '../assets/sampleData/poetry_french/submissions.pdf?url';
import poetry_german_blank from '../assets/sampleData/poetry_german/blank_exam.pdf?url';
import poetry_german_gs from '../assets/sampleData/poetry_german/grading_scheme.pdf?url';
import poetry_german_ms from '../assets/sampleData/poetry_german/master_solution.pdf?url';
import poetry_german_submission from '../assets/sampleData/poetry_german/submissions.pdf?url';
import politik_12_german_blank from '../assets/sampleData/politik_12_german/blank_exam.pdf?url';
import politik_12_german_gs from '../assets/sampleData/politik_12_german/grading_scheme.pdf?url';
import politik_12_german_ms from '../assets/sampleData/politik_12_german/master_solution.pdf?url';
import politik_12_german_submission from '../assets/sampleData/politik_12_german/submissions.pdf?url';

export type SampleFileRole = 'submission' | 'masterSolution' | 'gradingScheme' | 'blankExam';

export type SampleExamSubjectKey =
  | 'math'
  | 'english'
  | 'technical'
  | 'biology'
  | 'french'
  | 'spanish'
  | 'physics'
  | 'political_education'
  | 'german';

export type SampleExamLanguage = 'de' | 'en' | 'fr' | 'es';

export const EXAM_LANGUAGE_FLAGS: Record<SampleExamLanguage, string> = {
  de: '🇩🇪',
  en: '🇬🇧',
  fr: '🇫🇷',
  es: '🇪🇸',
};

export interface SampleExamFile {
  url: string;
  fileName: string;
  role: SampleFileRole;
}

export interface SampleExam {
  id: string;
  nameKey: string;
  subjectKey: SampleExamSubjectKey;
  gradeKey: string;
  descriptionKey: string;
  files: SampleExamFile[];
  numStudents?: number;
  examLanguage?: SampleExamLanguage;
}

export const ROLE_LABEL_KEYS: Record<SampleFileRole, string> = {
  submission: 'upload.categorySubmissions',
  masterSolution: 'upload.categoryMasterSolution',
  gradingScheme: 'upload.categoryGradingScheme',
  blankExam: 'upload.categoryBlankExam',
};

export const SAMPLE_EXAMS: SampleExam[] = [
  {
    id: 'kaarst',
    nameKey: 'Canvas.demoSelector.exams.kaarst.name',
    subjectKey: 'math',
    gradeKey: 'Canvas.demoSelector.grades.gesamtschule',
    descriptionKey: 'Canvas.demoSelector.exams.kaarst.description',
    files: [
      { url: kaarstSubmission, fileName: 'gesamtschule_mathe_gk.pdf', role: 'submission' },
      { url: kaarstMs, fileName: 'gesamtschule_mathe_gk_Musterloesung.pdf', role: 'masterSolution' },
      { url: kaarstGs, fileName: 'gesamtschule_mathe_gk_Bewertungsschema.pdf', role: 'gradingScheme' },
      { url: kaarstBlank, fileName: 'gesamtschule_mathe_gk_blank_exam.pdf', role: 'blankExam' },
    ],
    numStudents: 9,
    examLanguage: 'de',
  },
  {
    id: 'arne',
    nameKey: 'Canvas.demoSelector.exams.arne.name',
    subjectKey: 'math',
    gradeKey: 'Canvas.demoSelector.grades.highSchool',
    descriptionKey: 'Canvas.demoSelector.exams.arne.description',
    files: [{ url: arneSubmission, fileName: 'Math_test_6th_grade.pdf', role: 'submission' }],
    numStudents: 24,
    examLanguage: 'de',
  },
  // {
  //   id: 'lyneham-math',
  //   nameKey: 'Canvas.demoSelector.exams.lynehamMath.name',
  //   subjectKey: 'math',
  //   gradeKey: 'Canvas.demoSelector.grades.elementarySchool',
  //   descriptionKey: 'Canvas.demoSelector.exams.lynehamMath.description',
  //   files: [{ url: lynMathSubmissionShort, fileName: 'Grundschule_Mathe.pdf', role: 'submission' }],
  //   numStudents: 25,
  //   examLanguage: 'en',
  // },
  // {
  //   id: 'lyneham-reading',
  //   name: 'Reading Comprehension',
  //   subject: 'Englisch',
  //   grade: 'Grundschule',
  //   description: 'Schülerabgaben, Bewertungsschema & Blanko-Klausur',
  //   files: [
  //     { url: lynReadingSubmission, fileName: 'Grundschule_reading.pdf', role: 'submission' },
  //     { url: lynReadingGs, fileName: 'Grundschule_reading_grading_scheme.pdf', role: 'gradingScheme' },
  //     { url: lynReadingBlank, fileName: 'Grundschule_reading_blank_exam.pdf', role: 'blankExam' },
  //   ],
  // },
  // {
  //   id: 'tuev-bauleiter',
  //   nameKey: 'Canvas.demoSelector.exams.tuevBauleiter.name',
  //   subjectKey: 'technical',
  //   gradeKey: 'Canvas.demoSelector.grades.vocationalSchool',
  //   descriptionKey: 'Canvas.demoSelector.exams.tuevBauleiter.description',
  //   files: [
  //     { url: tuebBauleiterSubmission, fileName: 'TUEV_Bauleiter_E102844.pdf', role: 'submission' },
  //     { url: tuebBauleiterMs, fileName: 'TUEV_Bauleiter_E102844_Musterloesung.pdf', role: 'masterSolution' },
  //   ],
  //   numStudents: 3,
  //   examLanguage: 'de',
  // },
  // {
  //   id: 'tuv-datenschutz',
  //   name: 'Datenschutzauditor',
  //   subject: 'Berufsschule',
  //   grade: 'Erwachsenenbildung',
  //   description: 'Schülerabgaben & Musterlösung',
  //   files: [
  //     { url: tuvDatenschutzSubmission, fileName: 'TUEV_Datenschutzauditor.pdf', role: 'submission' },
  //     { url: tuvDatenschutzMs, fileName: 'TUEV_Datenschutzauditor_Musterloesung.pdf', role: 'masterSolution' },
  //   ],
  // },
  // {
  //   id: 'tuv-photovoltaik',
  //   nameKey: 'Canvas.demoSelector.exams.tuvPhotovoltaik.name',
  //   subjectKey: 'technical',
  //   gradeKey: 'Canvas.demoSelector.grades.vocationalSchool',
  //   descriptionKey: 'Canvas.demoSelector.exams.tuvPhotovoltaik.description',
  //   files: [
  //     { url: tuvPhotovoltaikSubmission, fileName: 'TUEV_Photovoltaik.pdf', role: 'submission' },
  //     { url: tuvPhotovoltaikMs, fileName: 'TUEV_Photovoltaik_Musterloesung.pdf', role: 'masterSolution' },
  //   ],
  //   numStudents: 3,
  //   examLanguage: 'de',
  // },
  {
    id: 'eng-vocabulary',
    nameKey: 'Canvas.demoSelector.exams.engVocabulary.name',
    subjectKey: 'english',
    gradeKey: 'Canvas.demoSelector.grades.middleSchool',
    descriptionKey: 'Canvas.demoSelector.exams.engVocabulary.description',
    files: [
      { url: eng_vocabulary_submission, fileName: 'eng_vocabulary_submissions.pdf', role: 'submission' },
      { url: eng_vocabulary_ms, fileName: 'eng_vocabulary_master_solution.pdf', role: 'masterSolution' },
      { url: eng_vocabulary_gs, fileName: 'eng_vocabulary_grading_scheme.pdf', role: 'gradingScheme' },
      { url: eng_vocabulary_blank_exam, fileName: 'eng_vocabulary_blank_exam.pdf', role: 'blankExam' },
    ],
    numStudents: 5,
    examLanguage: 'de',
  },
  {
    id: 'bio-image-labeling',
    nameKey: 'Canvas.demoSelector.exams.bioImageLabeling.name',
    subjectKey: 'biology',
    gradeKey: 'Canvas.demoSelector.grades.middleSchool',
    descriptionKey: 'Canvas.demoSelector.exams.bioImageLabeling.description',
    files: [
      { url: bio_imageLabel_submissions, fileName: 'bio_imageLabel_submissions.pdf', role: 'submission' },
      { url: bio_imageLabel_ms, fileName: 'bio_imageLabel_master_solution.pdf', role: 'masterSolution' },
      { url: bio_imageLabel_blank, fileName: 'bio_imageLabel_blank_exam.pdf', role: 'blankExam' },
    ],
    numStudents: 3,
    examLanguage: 'de',
  },
  {
    id: 'math-proof-eng',
    nameKey: 'Canvas.demoSelector.exams.mathProofEng.name',
    subjectKey: 'math',
    gradeKey: 'Canvas.demoSelector.grades.university',
    descriptionKey: 'Canvas.demoSelector.exams.mathProofEng.description',
    files: [
      { url: math_proof_eng_submission, fileName: 'math_proof_eng_submission.pdf', role: 'submission' },
      { url: math_proof_eng_ms, fileName: 'math_proof_eng_master_solution.pdf', role: 'masterSolution' },
      { url: math_proof_eng_gs, fileName: 'math_proof_eng_grading_scheme.pdf', role: 'gradingScheme' },
      { url: math_proof_eng_blank_exam, fileName: 'math_proof_eng_blank_exam.pdf', role: 'blankExam' },
    ],
    numStudents: 4,
    examLanguage: 'en',
  },
  {
    id: 'math-proof-fr',
    nameKey: 'Canvas.demoSelector.exams.mathProofFr.name',
    subjectKey: 'math',
    gradeKey: 'Canvas.demoSelector.grades.university',
    descriptionKey: 'Canvas.demoSelector.exams.mathProofFr.description',
    files: [
      { url: math_proof_fr_submission, fileName: 'math_proof_fr_submission.pdf', role: 'submission' },
      { url: math_proof_fr_ms, fileName: 'math_proof_fr_master_solution.pdf', role: 'masterSolution' },
      { url: math_proof_fr_gs, fileName: 'math_proof_fr_grading_scheme.pdf', role: 'gradingScheme' },
      { url: math_proof_fr_blank_exam, fileName: 'math_proof_fr_blank_exam.pdf', role: 'blankExam' },
    ],
    numStudents: 3,
    examLanguage: 'fr',
  },
  {
    id: 'plotting',
    nameKey: 'Canvas.demoSelector.exams.plotting.name',
    subjectKey: 'math',
    gradeKey: 'Canvas.demoSelector.grades.highSchool',
    descriptionKey: 'Canvas.demoSelector.exams.plotting.description',
    files: [
      { url: plot_exam, fileName: 'plot_exam.pdf', role: 'submission' },
      { url: plot_ms, fileName: 'plot_ms.pdf', role: 'masterSolution' },
      { url: plot_gs, fileName: 'plot_gs.pdf', role: 'gradingScheme' },
      { url: plot_blank, fileName: 'plot_blank.pdf', role: 'blankExam' },
    ],
    numStudents: 5,
    examLanguage: 'de',
  },
  {
    id: 'curve-analysis',
    nameKey: 'Canvas.demoSelector.exams.curveAnalysis.name',
    subjectKey: 'math',
    gradeKey: 'Canvas.demoSelector.grades.highSchool',
    descriptionKey: 'Canvas.demoSelector.exams.curveAnalysis.description',
    files: [
      { url: curve_submissions, fileName: 'curve_exam.pdf', role: 'submission' },
      { url: curve_ms, fileName: 'curve_ms.pdf', role: 'masterSolution' },
      { url: curve_gs, fileName: 'curve_gs.pdf', role: 'gradingScheme' },
      { url: curve_blank, fileName: 'curve_blank.pdf', role: 'blankExam' },
    ],
    numStudents: 5,
    examLanguage: 'de',
  },
  {
    id: 'dictation-fr',
    nameKey: 'Canvas.demoSelector.exams.dictationFr.name',
    subjectKey: 'french',
    gradeKey: 'Canvas.demoSelector.grades.primarySchool',
    descriptionKey: 'Canvas.demoSelector.exams.dictationFr.description',
    files: [
      { url: dictation_submission_fr, fileName: 'dictation_submission_fr.pdf', role: 'submission' },
      { url: dictation_ms_fr, fileName: 'dictation_ms_fr.pdf', role: 'masterSolution' },
      { url: dictation_gs_fr, fileName: 'dictation_gs_fr.pdf', role: 'gradingScheme' },
      { url: dictation_blank_fr, fileName: 'dictation_blank_fr.pdf', role: 'blankExam' },
    ],
    numStudents: 4,
    examLanguage: 'fr',
  },
  {
    id: 'dictation-es',
    nameKey: 'Canvas.demoSelector.exams.dictationEs.name',
    subjectKey: 'spanish',
    gradeKey: 'Canvas.demoSelector.grades.primarySchool',
    descriptionKey: 'Canvas.demoSelector.exams.dictationEs.description',
    files: [
      { url: dictation_submission_es, fileName: 'dictation_submission_es.pdf', role: 'submission' },
      { url: dictation_ms_es, fileName: 'dictation_ms_es.pdf', role: 'masterSolution' },
      { url: dictation_gs_es, fileName: 'dictation_gs_es.pdf', role: 'gradingScheme' },
      { url: dictation_blank_es, fileName: 'dictation_blank_es.pdf', role: 'blankExam' },
    ],
    numStudents: 4,
    examLanguage: 'es',
  },
  {
    id: 'calculation-de',
    nameKey: 'Canvas.demoSelector.exams.calculationDe.name',
    subjectKey: 'physics',
    gradeKey: 'Canvas.demoSelector.grades.highSchool',
    descriptionKey: 'Canvas.demoSelector.exams.calculationDe.description',
    files: [
      { url: calculation_submissions, fileName: 'calculation_submissions.pdf', role: 'submission' },
      { url: calculation_ms, fileName: 'calculation_ms.pdf', role: 'masterSolution' },
      { url: calculation_gs, fileName: 'calculation_gs.pdf', role: 'gradingScheme' },
      { url: calculation_blank, fileName: 'calculation_blank.pdf', role: 'blankExam' },
    ],
    numStudents: 3,
    examLanguage: 'de',
  },
  {
    id: 'calculation-fr',
    nameKey: 'Canvas.demoSelector.exams.calculationFr.name',
    subjectKey: 'math',
    gradeKey: 'Canvas.demoSelector.grades.highSchool',
    descriptionKey: 'Canvas.demoSelector.exams.calculationFr.description',
    files: [
      { url: calculation_french_submission, fileName: 'calculation_french_submissions.pdf', role: 'submission' },
      { url: calculation_french_ms, fileName: 'calculation_french_ms.pdf', role: 'masterSolution' },
      { url: calculation_french_gs, fileName: 'calculation_french_gs.pdf', role: 'gradingScheme' },
      { url: calculation_french_blank, fileName: 'calculation_french_blank.pdf', role: 'blankExam' },
    ],
    numStudents: 8,
    examLanguage: 'fr',
  },
  {
    id: 'calculation-es',
    nameKey: 'Canvas.demoSelector.exams.calculationEs.name',
    subjectKey: 'math',
    gradeKey: 'Canvas.demoSelector.grades.highSchool',
    descriptionKey: 'Canvas.demoSelector.exams.calculationEs.description',
    files: [
      { url: calculation_spanish_submission, fileName: 'calculation_spanish_submissions.pdf', role: 'submission' },
      { url: calculation_spanish_ms, fileName: 'calculation_spanish_ms.pdf', role: 'masterSolution' },
      { url: calculation_spanish_gs, fileName: 'calculation_spanish_gs.pdf', role: 'gradingScheme' },
      { url: calculation_spanish_blank, fileName: 'calculation_spanish_blank.pdf', role: 'blankExam' },
    ],
    numStudents: 8,
    examLanguage: 'es',
  },
  {
    id: 'calculation-en',
    nameKey: 'Canvas.demoSelector.exams.calculationEn.name',
    subjectKey: 'math',
    gradeKey: 'Canvas.demoSelector.grades.highSchool',
    descriptionKey: 'Canvas.demoSelector.exams.calculationEn.description',
    files: [
      { url: calculation_english_submission, fileName: 'calculation_english_submissions.pdf', role: 'submission' },
      { url: calculation_english_ms, fileName: 'calculation_english_ms.pdf', role: 'masterSolution' },
      { url: calculation_english_gs, fileName: 'calculation_english_gs.pdf', role: 'gradingScheme' },
      { url: calculation_english_blank, fileName: 'calculation_english_blank.pdf', role: 'blankExam' },
    ],
    numStudents: 6,
    examLanguage: 'en',
  },
  {
    id: 'multiple-choice-de',
    nameKey: 'Canvas.demoSelector.exams.multipleChoiceDe.name',
    subjectKey: 'math',
    gradeKey: 'Canvas.demoSelector.grades.highSchool',
    descriptionKey: 'Canvas.demoSelector.exams.multipleChoiceDe.description',
    files: [
      {
        url: multiple_choice_german_submission,
        fileName: 'multiple_choice_german_submissions.pdf',
        role: 'submission',
      },
      { url: multiple_choice_german_ms, fileName: 'multiple_choice_german_ms.pdf', role: 'masterSolution' },
      { url: multiple_choice_german_gs, fileName: 'multiple_choice_german_gs.pdf', role: 'gradingScheme' },
      { url: multiple_choice_german_blank, fileName: 'multiple_choice_german_blank.pdf', role: 'blankExam' },
    ],
    numStudents: 6,
    examLanguage: 'de',
  },
  {
    id: 'multiple-choice-en',
    nameKey: 'Canvas.demoSelector.exams.multipleChoiceEn.name',
    subjectKey: 'technical',
    gradeKey: 'Canvas.demoSelector.grades.vocationalSchool',
    descriptionKey: 'Canvas.demoSelector.exams.multipleChoiceEn.description',
    files: [
      {
        url: multiple_choice_english_submission,
        fileName: 'multiple_choice_english_submissions.pdf',
        role: 'submission',
      },
      { url: multiple_choice_english_ms, fileName: 'multiple_choice_english_ms.pdf', role: 'masterSolution' },
      { url: multiple_choice_english_gs, fileName: 'multiple_choice_english_gs.pdf', role: 'gradingScheme' },
      { url: multiple_choice_english_blank, fileName: 'multiple_choice_english_blank.pdf', role: 'blankExam' },
    ],
    numStudents: 6,
    examLanguage: 'en',
  },
  {
    id: 'calculation-de',
    nameKey: 'Canvas.demoSelector.exams.calculationDe.name',
    subjectKey: 'math',
    gradeKey: 'Canvas.demoSelector.grades.highSchool',
    descriptionKey: 'Canvas.demoSelector.exams.calculationDe.description',
    files: [
      { url: calculation_german_submission, fileName: 'calculation_german_submissions.pdf', role: 'submission' },
      { url: calculation_german_ms, fileName: 'calculation_german_ms.pdf', role: 'masterSolution' },
      { url: calculation_german_gs, fileName: 'calculation_german_gs.pdf', role: 'gradingScheme' },
      { url: calculation_german_blank, fileName: 'calculation_german_blank.pdf', role: 'blankExam' },
    ],
    numStudents: 15,
    examLanguage: 'de',
  },
  {
    id: 'politics-12-german',
    nameKey: 'Canvas.demoSelector.exams.politics12German.name',
    subjectKey: 'political_education',
    gradeKey: 'Canvas.demoSelector.grades.highSchool',
    descriptionKey: 'Canvas.demoSelector.exams.politics12German.description',
    files: [
      { url: politik_12_german_submission, fileName: 'submissions.pdf', role: 'submission' },
      { url: politik_12_german_ms, fileName: 'master_solution.pdf', role: 'masterSolution' },
      { url: politik_12_german_gs, fileName: 'grading_scheme.pdf', role: 'gradingScheme' },
      { url: politik_12_german_blank, fileName: 'blank_exam.pdf', role: 'blankExam' },
    ],
    numStudents: 15,
    examLanguage: 'de',
  },
  {
    id: 'multiple-choice-fr',
    nameKey: 'Canvas.demoSelector.exams.multipleChoiceFr.name',
    subjectKey: 'technical',
    gradeKey: 'Canvas.demoSelector.grades.highSchool',
    descriptionKey: 'Canvas.demoSelector.exams.multipleChoiceFr.description',
    files: [
      {
        url: multiple_choice_french_submission,
        fileName: 'multiple_choice_french_submissions.pdf',
        role: 'submission',
      },
      { url: multiple_choice_french_ms, fileName: 'multiple_choice_french_ms.pdf', role: 'masterSolution' },
      { url: multiple_choice_french_gs, fileName: 'multiple_choice_french_gs.pdf', role: 'gradingScheme' },
      { url: multiple_choice_french_blank, fileName: 'multiple_choice_french_blank.pdf', role: 'blankExam' },
    ],
    numStudents: 6,
    examLanguage: 'fr',
  },
  {
    id: 'multiple-choice-es',
    nameKey: 'Canvas.demoSelector.exams.multipleChoiceEs.name',
    subjectKey: 'technical',
    gradeKey: 'Canvas.demoSelector.grades.highSchool',
    descriptionKey: 'Canvas.demoSelector.exams.multipleChoiceEs.description',
    files: [
      {
        url: multiple_choice_spanish_submission,
        fileName: 'multiple_choice_spanish_submissions.pdf',
        role: 'submission',
      },
      { url: multiple_choice_spanish_ms, fileName: 'multiple_choice_spanish_ms.pdf', role: 'masterSolution' },
      { url: multiple_choice_spanish_gs, fileName: 'multiple_choice_spanish_gs.pdf', role: 'gradingScheme' },
      { url: multiple_choice_spanish_blank, fileName: 'multiple_choice_spanish_blank.pdf', role: 'blankExam' },
    ],
    numStudents: 5,
    examLanguage: 'es',
  },
  {
    id: 'poetry-12-german',
    nameKey: 'Canvas.demoSelector.exams.poetry12German.name',
    subjectKey: 'german',
    gradeKey: 'Canvas.demoSelector.grades.highSchool',
    descriptionKey: 'Canvas.demoSelector.exams.poetry12German.description',
    files: [
      { url: poetry_german_submission, fileName: 'submissions.pdf', role: 'submission' },
      { url: poetry_german_ms, fileName: 'master_solution.pdf', role: 'masterSolution' },
      { url: poetry_german_gs, fileName: 'grading_scheme.pdf', role: 'gradingScheme' },
      { url: poetry_german_blank, fileName: 'blank_exam.pdf', role: 'blankExam' },
    ],
    numStudents: 7,
    examLanguage: 'de',
  },
  {
    id: 'poetry-12-english',
    nameKey: 'Canvas.demoSelector.exams.poetry12English.name',
    subjectKey: 'english',
    gradeKey: 'Canvas.demoSelector.grades.highSchool',
    descriptionKey: 'Canvas.demoSelector.exams.poetry12English.description',
    files: [
      { url: poetry_english_submission, fileName: 'submissions.pdf', role: 'submission' },
      { url: poetry_english_ms, fileName: 'master_solution.pdf', role: 'masterSolution' },
      { url: poetry_english_gs, fileName: 'grading_scheme.pdf', role: 'gradingScheme' },
      { url: poetry_english_blank, fileName: 'blank_exam.pdf', role: 'blankExam' },
    ],
    numStudents: 7,
    examLanguage: 'en',
  },
  {
    id: 'poetry-12-french',
    nameKey: 'Canvas.demoSelector.exams.poetry12French.name',
    subjectKey: 'french',
    gradeKey: 'Canvas.demoSelector.grades.highSchool',
    descriptionKey: 'Canvas.demoSelector.exams.poetry12French.description',
    files: [
      { url: poetry_french_submission, fileName: 'submissions.pdf', role: 'submission' },
      { url: poetry_french_ms, fileName: 'master_solution.pdf', role: 'masterSolution' },
      { url: poetry_french_gs, fileName: 'grading_scheme.pdf', role: 'gradingScheme' },
      { url: poetry_french_blank, fileName: 'blank_exam.pdf', role: 'blankExam' },
    ],
    numStudents: 7,
    examLanguage: 'fr',
  },
  {
    id: 'material-based-english',
    nameKey: 'Canvas.demoSelector.exams.materialBasedEnglish.name',
    subjectKey: 'english',
    gradeKey: 'Canvas.demoSelector.grades.highSchool',
    descriptionKey: 'Canvas.demoSelector.exams.materialBasedEnglish.description',
    files: [
      { url: material_based_english_submission, fileName: 'submissions.pdf', role: 'submission' },
      { url: material_based_english_ms, fileName: 'master_solution.pdf', role: 'masterSolution' },
      { url: material_based_english_gs, fileName: 'grading_scheme.pdf', role: 'gradingScheme' },
      { url: material_based_english_blank, fileName: 'blank_exam.pdf', role: 'blankExam' },
    ],
    numStudents: 7,
    examLanguage: 'en',
  },
  {
    id: 'material-based-german',
    nameKey: 'Canvas.demoSelector.exams.materialBasedGerman.name',
    subjectKey: 'german',
    gradeKey: 'Canvas.demoSelector.grades.highSchool',
    descriptionKey: 'Canvas.demoSelector.exams.materialBasedGerman.description',
    files: [
      { url: material_based_german_submission, fileName: 'submissions.pdf', role: 'submission' },
      { url: material_based_german_ms, fileName: 'master_solution.pdf', role: 'masterSolution' },
      { url: material_based_german_gs, fileName: 'grading_scheme.pdf', role: 'gradingScheme' },
      { url: material_based_german_blank, fileName: 'blank_exam.pdf', role: 'blankExam' },
    ],
    numStudents: 5,
    examLanguage: 'de',
  },
];

export const SAMPLE_EXAM_SUBJECTS = [...new Set(SAMPLE_EXAMS.map(e => e.subjectKey))];
